import { Box, HStack, IconButton } from '@rbilabs/universal-components';

import { getDesignToken, primitive } from 'styles/constants';
export const StyledButtonBox = Box.withConfig({
  flexDirection: 'row',
  flexWrap: 'wrap',
  alignItems: 'center',
  alignContent: 'center',
});

export const StyledRecentOrderCard = HStack.withConfig({
  borderBottomWidth: '1px',
  borderBottomColor: primitive.$mayoEggWhite,
  justifyContent: 'space-between',
  backgroundColor: getDesignToken('background-card'),
  paddingY: '$5',
  paddingX: '$4',
});

export const AddIconButton = IconButton.withConfig<{
  disabled?: boolean;
}>(p => ({
  padding: 0,
  borderColor: p.disabled ? getDesignToken('icon-disabled') : getDesignToken('increment-active'),
  _icon: {
    color: p.disabled ? getDesignToken('text-disabled') : getDesignToken('increment-active'),
  },
}));
